/** People Landing — campos del bloque "links". Hasta el 21/09/2026 vivía en BlockEditorDialog.tsx. */
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ArrowDown, ArrowUp, Plus, Trash2 } from 'lucide-react';
import { type LandingLinkItem } from '../../../../../../shared/types/people-landing';
import type { EditorFieldProps } from '../types';

export function LinksFields({ draft, set, setItem, removeItem, moveItem, setDraft }: EditorFieldProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.section_title', 'Título de sección (opcional)')}</Label>
        <Input value={draft.title ?? ''} onChange={(e) => set({ title: e.target.value })} />
      </div>
      <div className="space-y-2.5">
        {draft.items.map((item: LandingLinkItem, idx: number) => (
          <div key={item.id ?? idx} className="rounded-lg border p-3 space-y-2">
            <div className="flex items-center gap-2">
              <Input
                placeholder={t('people_landing.editor.link_title', 'Título del botón')}
                value={item.title ?? ''}
                onChange={(e) => setItem(idx, { title: e.target.value })}
              />
              <div className="flex gap-0.5 shrink-0">
                <Button type="button" variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={() => moveItem(idx, -1)} disabled={idx === 0}>
                  <ArrowUp className="h-3.5 w-3.5" />
                </Button>
                <Button type="button" variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={() => moveItem(idx, 1)} disabled={idx === draft.items.length - 1}>
                  <ArrowDown className="h-3.5 w-3.5" />
                </Button>
                <Button type="button" variant="ghost" size="sm" className="h-8 w-8 p-0 text-destructive" onClick={() => removeItem(idx)}>
                  <Trash2 className="h-3.5 w-3.5" />
                </Button>
              </div>
            </div>
            <Input
              placeholder="https://…"
              value={item.url ?? ''}
              onChange={(e) => setItem(idx, { url: e.target.value })}
            />
            <Input
              placeholder={t('people_landing.editor.link_description', 'Descripción (opcional)')}
              value={item.description ?? ''}
              onChange={(e) => setItem(idx, { description: e.target.value })}
            />
          </div>
        ))}
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() =>
            setDraft((d: any) => ({ ...d, items: [...d.items, { id: uuidv4() }] }))
          }
        >
          <Plus className="mr-1.5 h-3.5 w-3.5" />
          {t('people_landing.editor.add_link', 'Agregar link')}
        </Button>
      </div>
    </>
  );
}
